function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

const AccessContext = require('./contexts/access-context');

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

const PagedList = require('../entities/paged-list');

const fields = ['id', 'name'];
const createFields = ['id', 'apiToken'];
const accessFields = ['id', 'role.id', 'role.sid', 'role.name', 'role.type', 'propertyId', 'businessId', 'locationId'];

class TokenRepo {
  constructor(client
  /*: ApiClient*/
  , id
  /*: destinationId*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.id = id;
    this.context = context;
  }

  promote(roleId
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const apiTokenId = this.id;
    const {
      propertyId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/apiTokens/promote`;
    const req = new this.client.Request(path, {
      apiTokenId,
      roleId
    }, accessFields);
    return this.client.post(req);
  }

  demote(roleId
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const apiTokenId = this.id;
    const {
      propertyId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/apiTokens/demote`;
    const req = new this.client.Request(path, {
      apiTokenId,
      roleId
    });
    return this.client.post(req);
  }

  demoteAll()
  /*: Promise<boolean>*/
  {
    const _this = this;

    return _call(function () {
      return _await(_this.accesses(), function (accesses) {
        return _await(Promise.all(accesses.items.map(access => _this.demote(access.role.id))), function () {
          return true;
        });
      });
    });
  }

  accesses()
  /*: Promise<PagedList<Object>>*/
  {
    const apiTokenId = this.id;
    const {
      propertyId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/apiTokens/accesses`;
    const req = new this.client.Request(path, {
      apiTokenId
    }, accessFields);
    req.useCursor = true;
    return this.client.get(req);
  }

  delete()
  /*: (Promise<boolean>)*/
  {
    const _this2 = this;

    return _call(function () {
      const {
        propertyId
      } = _this2.context.serialize();

      return _await(_this2.client.delete(new _this2.client.Request(`/properties/${propertyId}/apiTokens/${_this2.id}`)));
    });
  }

}

class TokensRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  ) {
    this.context = context;
    this.client = client;

    this.for = (id
    /*: tokenId*/
    ) => new TokenRepo(client, id, this.context);

    this.icanhas = this.for;
  }

  list() {
    const {
      propertyId
    } = this.context.serialize();
    const req = new this.client.Request(`/properties/${propertyId}/apiTokens/search`, {}, fields);
    return this.client.get(req);
  }

  create(instance
  /*: Object*/
  , requestedRoleSid
  /*: string*/
  = 'property-read-access') {
    const _this3 = this;

    return _call(function () {
      if (instance.id != null) throw new Error('Object already has id');

      const {
        propertyId
      } = _this3.context.serialize();

      const req = new _this3.client.Request(`/properties/${propertyId}/apiTokens`, instance, createFields);
      return _await(_this3.client.post(req), function (token) {
        return _await(_this3.client.roles.list({
          type: 'property'
        }), function (roles) {
          const roleId = roles.items.find(r => r.sid === requestedRoleSid).id;
          return _await(_this3.for(token.id).promote(roleId), function () {
            return token;
          });
        });
      });
    });
  }

}

module.exports = TokensRepo;